import { NgModule } from '@angular/core';
import { ArrowLeft, LucideAngularModule } from 'lucide-angular';

const lucide = LucideAngularModule.pick({ ArrowLeft });

@NgModule({
  imports: [lucide],
  exports: [LucideAngularModule],
})
export class PageBackIconsModule {}
